/** Key injected in object to access reCAPTCHA client token */
export const googleReCaptchaInjectedKey = "__reCaptchaClientToken";

/** ReCAPTCHA action string to use in verification*/
export const reCAPTCHAAction = "activmed/verify/captcha";